import { usePledgeCancelQuery } from '../data-access/queries/usePledgeCancelQuery';

export const useWCPledgeCancelPost = () => {
	const { error, isError, isPending, isSuccess, mutateAsync: cancelPledgeAsync } = usePledgeCancelQuery();

	const cancelPledgeMutation = ({ teamId, transactionHash }: { teamId: string; transactionHash: string }) => {
		return cancelPledgeAsync({ data: { transactionHash }, teamId });
	};

	return {
		cancelPledgeMutation,
		isPledgeCancelPosting: isPending,
		isPostPledgeError: isError,
		isPostPledgeSuccess: isSuccess,
		postPledgeError: error
	};
};
